export const network = "mainnet";
export const contractAddress = "0x206DA90BBAfF3bd422eD59E68D44201ceDdA3d8c";
export const draHelperContractAddress = "0x6Cea723dDE046A0806047C9077BA3650A71DA01d";
export const websiteURL = "https://swssdraw.io";
export const fromBlock = "0";
export const defaultAddress = "0x0000000000000000000000000000000000000000";
export const ReOwnProjectId = "015a12d4c6220651a0f75bbda85e2edc";
export const apiURL = "https://api.swssdraw.io";
export const superAdmins = ["0x54DC14A488d47d48A3aF44e2a3b833E684e2B3A7"];
